import { BookLockOpenIcon } from './BookLockOpenIcon';

/**
 * author: Michael Richins
 * id 90B49606-B4FF-4D4B-AE05-4769659094CE
 * name book-lock-open
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-lock-open.svg
 * tags
 * - Lock 
 */
export const BookUnsecureIcon = BookLockOpenIcon;
export default BookUnsecureIcon